import { FormControlLabel } from '@mui/material';
import { BaseFormControlLabelProps } from './BaseFormControlLabel.types';

/**
 * The Base MUI `FormControlLabel` used by our wrapper components. Created here to provide
 * separation for jest mocks.
 *
 * @param classes - {@link BaseFormControlLabelProps.classes classes} description.
 * @param control - {@link BaseFormControlLabelProps.control control} description.
 * @param label - {@link BaseFormControlLabelProps.label label} description.
 * @param labelPlacement - {@link BaseFormControlLabelProps.labelPlacement labelPlacement} description.
 * @param value - {@link BaseFormControlLabelProps.value value} description.
 * @param required - {@link BaseFormControlLabelProps.required required} description.
 */
export const BaseFormControlLabel = ({
    classes,
    control,
    label,
    labelPlacement,
    value,
    required,
}: BaseFormControlLabelProps) => {
    return (
        <FormControlLabel
            classes={{
                ...classes,
            }}
            disableTypography
            control={control}
            label={label}
            labelPlacement={labelPlacement}
            value={value}
            required={required}
        />
    );
};